import { AssetSource } from '@/modules/academy/enums'

export function transformImagePaths(content: string, assetSource: AssetSource = AssetSource.QUICK_START): string {
  const markdownImageRegex = /!\[([^\]]*)\]\(((?:\.\.\/)*(?:\.\/)?@?assets\/)([^)]+)\)/g
  let result = content.replace(markdownImageRegex, (_match, alt, _prefix, filename) => {
    const imageUrl = `/assets/${assetSource}/${filename}`
    return `![${alt}](${imageUrl})`
  })

  const htmlImageRegex = /<img([^>]*)\ssrc=["']((?:\.\.\/)*(?:\.\/)?@?assets\/)([^"']+)["']([^>]*)>/gi
  result = result.replace(htmlImageRegex, (_match, before, _prefix, filename, after) => {
    const imageUrl = `/assets/${assetSource}/${filename}`
    return `<img${before} src="${imageUrl}"${after}>`
  })

  const srcAttributeRegex = /src=["']((?:\.\.\/)*(?:\.\/)?@?assets\/)([^"']+)["']/g
  result = result.replace(srcAttributeRegex, (_match, _prefix, filename) => {
    const imageUrl = `/assets/${assetSource}/${filename}`
    return `src="${imageUrl}"`
  })

  return result
}
